module.exports = __webpack_public_path__ + "img/image_2.5d44b809.png";